import React from 'react';
import MarinaNavigation from './MarinaNavigation';

interface MarinaLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  showNavigation?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
}

const MarinaLayout: React.FC<MarinaLayoutProps> = ({ 
  children, 
  title = "Online Booking System",
  subtitle = "Secure your perfect seaside getaway",
  showNavigation = true,
  showHeader = true,
  showFooter = true,
}) => {
  return (
    <div className="marina-layout">
      {showNavigation && <MarinaNavigation />}
      
      {showHeader && (
        <div className="booking-header">
          <div className="container">
            <span className="booking-eyebrow">Marina Glen Booking</span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      )}
      
      <main className="booking-main">
        <div className="container">
          {children}
        </div>
      </main>
      
      {showFooter && (
        <footer className="booking-footer">
          <div className="container">
            <p className="booking-footer-links">
              <span>© 2025 Marina Glen Holiday Resort.</span>
              <a href="/index.html">Visit our main website</a>
              <a href="tel:+27393121234">+27 39 312 1234</a>
              <a href="mailto:bookings@marinaglen.co.za">bookings@marinaglen.co.za</a>
            </p>
            <p className="booking-footer-meta">
              <span>17 Mars Road, Marina Beach, KZN</span>
              <span>Secure Online Booking Platform</span>
              <a href="/booking-system/login" className="staff-login-link">Staff Login</a>
            </p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default MarinaLayout;